var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"overlay-blood-pressure-with-selfie"}},[_c('icon',{attrs:{"data":require("@icon/overlay/evidence-guideline-bp.svg")}}),_c('icon',{attrs:{"data":require("@icon/overlay/evidence-guideline-face.svg")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }